import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  footerStyle: {
    zIndex: 10,
    backgroundColor: theme.palette.neutralLighterAlt,
    width: '100%',
    boxShadow: `-1px -4px 13px rgba(0, 0, 0, 0.15)`,
  },
  diabledButton: {
    marginLeft: 20,
    marginRight: 5,
    ':disabled': {
      color: theme.palette.neutralTertiary,
    },
  },
  shimmerViewMainContainer: {
    marginTop: 30,
    marginBottom: 90,
  },
  headerContainer: {
    paddingLeft: 25,
    paddingRight: 25,
  },
  marginTop20: {
    marginTop: 20,
  },
  marginTop10: {
    marginTop: 10,
  },
  paddingTop10: {
    paddingTop: 10,
  },
  tagsContainer: {
    marginTop: 20,
    paddingLeft: 25,
    paddingRight: 25,
    marginBottom: 20,
  },
  requestedByText: {
    marginLeft: 10,
    fontWeight: 'bold',
  },
}));
